<template>
  <div class="router-links">
    <router-link
      target="_blank"
      :to="{
        name: 'company-positions',
        query: { company_id: company_id, sort: '-is_hot' }
      }"
      class="button is-hovered is-outlined"
      ><p>Positions</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-employees',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>Employees</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-texts',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>Texts</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-educations',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>Educations</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-locations',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>Locations</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-questions',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>Questions</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-history-companies',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>History Companies</p></router-link
    >
    <router-link
      target="_blank"
      :to="{
        name: 'company-meetings',
        query: { company_id: company_id }
      }"
      class="button is-hovered is-outlined"
      ><p>Meetings</p></router-link
    >
  </div>
</template>
<script>
export default {
  name: 'company-form-links',
  props: ['company_id']
}
</script>
